"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Translate_1 = require("../Translate/Translate");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var SearchBar_1 = __importDefault(require("./styledComponents/SearchBar"));

var SearchIcon_1 = __importDefault(require("./styledComponents/SearchIcon"));

var ResultBackground_1 = __importDefault(require("./styledComponents/ResultBackground"));

var ResultCard_1 = __importDefault(require("./styledComponents/ResultCard"));

var ResultElement_1 = __importDefault(require("./styledComponents/ResultElement"));

var SearchPill_1 = __importDefault(require("./styledComponents/SearchPill"));

var SearchClear_1 = __importDefault(require("./styledComponents/SearchClear"));

var Input_1 = __importDefault(require("../Input"));

var SearchStore_1 = __importDefault(require("./SearchStore"));

var Search_meta_1 = require("./Search.meta");

var mobx_1 = require("mobx");

var SEARCH_ACTIONS = ['UPDATED_TERM', 'UPDATED_RESULTS', 'UPDATED_RESULT_DISPLAY', 'UPDATED_SEARCH_STATUS', 'UPDATED_PILL_PROPS'];

var Search =
/** @class */
function (_super) {
  __extends(Search, _super);

  function Search(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Search_meta_1.SEARCH_CATEGORY_KEY;
    _this.componentKey = Search_meta_1.SEARCH_COMPONENT_KEY;
    _this.onChange = _this.onChange.bind(_this);
    _this.updateLastAction = _this.updateLastAction.bind(_this);
    _this.SearchStore = new SearchStore_1.default(_this.updateLastAction, props);
    return _this;
  }

  Search.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a = this.props,
        term = _a.term,
        pillProps = _a.pillProps;
    this.SearchStore.setupPillProps(pillProps);

    if (term) {
      this.SearchStore.setTerm(term);
    }
  };

  Search.prototype.onChange = function (e) {
    var _this = this;

    var searchCallback = this.props.searchCallback;
    var searchTerm = ksys_app_template_1.utils.object.safe(function () {
      return e.target.value;
    }, '') || '';
    this.SearchStore.setTerm(searchTerm);

    if (searchCallback && searchTerm.length >= this.minCharacterTrigger) {
      this.SearchStore.setIsSearching(true); // debounce

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }

      this.timeout = setTimeout(function () {
        _this.SearchStore.fetchResults();
      }, this.onChangeMillisecondTimeout);
    } else {
      this.SearchStore.hideResults();
      this.SearchStore.resetPillProps();
    }
  };

  Search.prototype.updateLastAction = function (action) {
    this.lastAction = action;
  };

  Object.defineProperty(Search.prototype, "term", {
    get: function get() {
      return this.SearchStore.term;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "isSearching", {
    get: function get() {
      return this.SearchStore.isSearching;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "pillProps", {
    get: function get() {
      return this.SearchStore.pillProps;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "results", {
    get: function get() {
      return this.SearchStore.results;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "minCharacterTrigger", {
    get: function get() {
      return this.props.minCharacterTrigger || 3;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "onChangeMillisecondTimeout", {
    get: function get() {
      return this.props.onChangeMillisecondTimeout || 1000;
    },
    enumerable: true,
    configurable: true
  });

  Search.prototype.getAsset = function (isSearching) {
    return isSearching ? 'base.search.spinner' : 'base.search.magnificationGlass';
  };

  Object.defineProperty(Search.prototype, "resultElements", {
    get: function get() {
      var _this = this;

      var ResultItemComponent = this.props.resultItemComponent;

      if (this.SearchStore.showResults) {
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ResultCard_1.default, null, this.results.map(function (record, index) {
          return react_1.default.createElement(ResultElement_1.default, {
            key: "result-element-" + index,
            onClick: function onClick() {
              return _this.SearchStore.clickRecord(record);
            }
          }, ResultItemComponent ? react_1.default.createElement(ResultItemComponent, {
            record: record
          }) : record.value);
        })));
      }

      return null;
    },
    enumerable: true,
    configurable: true
  });

  Search.prototype.getPlaceholder = function (translationContext) {
    var placeholder = this.props.placeholder;
    return placeholder ? translationContext.translate(placeholder) : placeholder;
  };

  Search.prototype.getAutoFocus = function () {
    var autoFocus = false;

    if (this.lastAction !== undefined && SEARCH_ACTIONS.indexOf(this.lastAction) >= 0) {
      this.lastAction = undefined;
      autoFocus = true;
    }

    return autoFocus;
  };

  Search.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        iconPosition = _a.iconPosition;
    var inputProps = {
      type: 'text',
      value: this.term,
      autoFocus: this.getAutoFocus(),
      onChange: this.onChange,
      onClick: function onClick() {
        return _this.SearchStore.displayResults;
      }
    };
    var iconProps = {
      asset: this.getAsset(this.isSearching)
    };
    var pillProps = this.pillProps;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
      // push translated placeholder onto inputProps
      var placeholder = _this.getPlaceholder(translationContext);

      Object.assign(inputProps, {
        placeholder: placeholder
      });
      return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(SearchBar_1.default, null, iconPosition === 'left' && react_1.default.createElement(SearchIcon_1.default, __assign({}, iconProps)), pillProps && pillProps.pillPosition === 'left' && react_1.default.createElement(SearchPill_1.default, __assign({}, pillProps)), react_1.default.createElement(Input_1.default, __assign({}, inputProps)), !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(_this.term) && react_1.default.createElement(SearchClear_1.default, {
        asset: "base.search.cross",
        onClick: function onClick() {
          return _this.SearchStore.reset();
        }
      }), pillProps && pillProps.pillPosition === 'right' && react_1.default.createElement(SearchPill_1.default, __assign({}, pillProps)), iconPosition === 'right' && react_1.default.createElement(SearchIcon_1.default, __assign({}, iconProps))), _this.resultElements);
    }), this.SearchStore.showResults && react_1.default.createElement(ResultBackground_1.default, {
      onClick: function onClick() {
        _this.SearchStore.hideResults();
      }
    }));
  };

  __decorate([mobx_1.computed], Search.prototype, "term", null);

  __decorate([mobx_1.computed], Search.prototype, "isSearching", null);

  __decorate([mobx_1.computed], Search.prototype, "pillProps", null);

  __decorate([mobx_1.computed], Search.prototype, "results", null);

  __decorate([mobx_1.computed], Search.prototype, "resultElements", null);

  Search = __decorate([mobx_react_1.observer], Search);
  return Search;
}(shared_1.ComponentBase);

exports.Search = Search;
exports.default = shared_1.InjectedStyledComponent(Search, Search_meta_1.SEARCH_CATEGORY_KEY, Search_meta_1.SEARCH_COMPONENT_KEY);